import { FunctionComponent } from "react";
import TextInput from "../text/TextInput";
import { Search } from "lucide-react";

interface ISearchBarProps {
  onChange: (term: string) => void;
}

const SearchBar: FunctionComponent<ISearchBarProps> = ({ onChange }) => (
  <div className="relative w-full md:w-1/2 mx-auto">
    <Search className="absolute left-3 top-2.5 text-black" size={18} />
    <TextInput
      id="searchbar"
      placeholder="Search records..."
      onChange={onChange}
      containerStyles="w-full"
    />
  </div>
);

export default SearchBar;
